import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#031f30",
      d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"
    }, null, -1),
    _createElementVNode("rect", {
      width: "7",
      height: "1.25",
      x: "4.5",
      y: "7.5",
      fill: "#fff",
      rx: ".625"
    }, null, -1)
  ]))]))
}
export default { render: render }